import { ApiCallError } from './ApiCallError';

const GENERIC_MESSAGE = 'Something went wrong. Please try again later.';
const NETWORK_MESSAGE = 'Network request failed. Check your connection and try again.';
const SESSION_REFRESHED_MESSAGE = 'Your session was refreshed. Please try again.';

const getBodyMessage = (body: unknown): string | undefined => {
  if (typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string') {
    return body.message.trim() || undefined;
  }
  return undefined;
};

export const getApiCallErrorMessage = (error: ApiCallError): string => {
  if (error.status === undefined) {
    return NETWORK_MESSAGE;
  }
  if (error.status === 418) {
    return error.refreshOutcome === 'network-failure' ? NETWORK_MESSAGE : SESSION_REFRESHED_MESSAGE;
  }
  if (error.status >= 500) {
    return GENERIC_MESSAGE;
  }
  return getBodyMessage(error.body) ?? GENERIC_MESSAGE;
};
